var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "100%",
      "max-width": "720",
      "content-class": "rounded-lg"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-sheet', {
    staticClass: "full-height"
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "fill-height": ""
    }
  }, [_c('bottom-sheet-header', {
    staticStyle: {
      "position": "relative"
    }
  }, [_vm._v(" 연령차별금지 주요내용 "), _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "fab": "",
      "tile": "",
      "absolute": "",
      "right": "",
      "color": "white"
    },
    on: {
      "click": function click($event) {
        _vm.shows = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-sheet', {
    staticClass: "scroll-primary py-40 px-60",
    staticStyle: {
      "flex": "1 1 auto",
      "overflow-y": "auto"
    }
  }, [_c('p', {
    staticClass: "page-text mb-12 mb-lg-20"
  }, [_vm._v("채용공고에 합리적인 이유 없이 “00세 이하”, “1900년 이후 출생자”, “2000년 졸업자”, “대학졸업 후 2년 이내” 등 직·간접적인 연령제한을 할 수 없게 되었습니다. 모집·채용에서 불합리한 연령제한 시 고용상 연령차별 금지 및 고령자 고용촉진에 관한 법률 위반에 따른 500만원 이하의 벌금이 부과될 수 있습니다.")]), _c('vertical-table', _vm._b({}, 'vertical-table', {
    items: _vm.items
  }, false), [_c('template', {
    slot: "차별로 보지 않는 사례"
  }, [_c('ul', [_c('li', {
    staticClass: "mb-4"
  }, [_vm._v("· 직무성질상 특정 연령기준이 불가피한 경우(진정직업자격)"), _c('br'), _vm._v("연극.영화에서 청년역할의 수행을 위한 연령제한 등")]), _c('li', {
    staticClass: "mb-4"
  }, [_vm._v("· 근속기간의 차이를 고려하여 임금이나 임금 외의 금품과 복리후생에서 합리적인 차등을 두는 경우")]), _c('li', {
    staticClass: "mb-4"
  }, [_vm._v("· 법률 등에 근거한 정년의 설정")]), _c('li', [_vm._v("· 이 법이나 다른 법률에 따라 특정 연령집단의 고용유지ㆍ촉진을 위한 지원조치를 하는 경우")])])])], 2)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }